import * as R from 'ramda';

export const updateAt = (id, transform) => R.map(R.when(R.propEq(id, 'id'), transform));
